import axios from 'axios';
import store from '../store/index';
import router from '../routes/index';
import * as Cookies from 'js-cookie';

const http = axios.create({
  baseURL: process.env.VUE_APP_PARTNERS_EXCELS,
});

if (store.state.auth.accessToken) {
  http.defaults.headers.Authorization = `Bearer ${store.state.auth.accessToken}`;
}

http.interceptors.response.use(undefined, response => new Promise(() => {
  if (response.status === 401) {
    store.dispatch('logout').then(() => {
      Cookies.remove('mozgoAuth', {domain: 'dev.mozgo.com'});
      store.dispatch('updateInterceptorsLogin', true);
      router.push('/');
    });
  }
  throw response;
}));

export default http;
